import questionnaire from './questionnaire';

const methodology = {
  normalizeLikert: (value) => {
    const x = parseInt(value, 10);
    if (Number.isNaN(x) || x < 1 || x > 5) return 0;
    return ((x - 1) / 4) * 100;
  },

  normalizeLikertInverted: (value) => {
    const x = parseInt(value, 10);
    if (Number.isNaN(x) || x < 1 || x > 5) return 0;
    return ((5 - x) / 4) * 100;
  },

  normalizeBinary: (value, positiveValue) => (value === positiveValue ? 100 : 0),

  calculateIndices: (formData) => {
    const allQuestions = questionnaire.getAllQuestions();
    const normalizedValues = {};

    allQuestions.forEach((q) => {
      const value = formData[q.id];
      if (value === undefined || value === null || value === '') {
        normalizedValues[q.id] = null;
        return;
      }

      if (q.type === 'likert') {
        if (q.invert) {
          normalizedValues[q.id] = methodology.normalizeLikertInverted(value);
        } else {
          normalizedValues[q.id] = methodology.normalizeLikert(value);
        }
      } else if (q.type === 'binary') {
        normalizedValues[q.id] = methodology.normalizeBinary(value, q.positive);
      }
    });

    const dimensionalIndices = {};
    questionnaire.getDimensions().forEach((dim) => {
      const dimQuestions = dim.questions.filter((q) => q.type === 'likert' || q.type === 'binary');
      const values = dimQuestions.map((q) => normalizedValues[q.id]).filter((v) => v !== null);

      if (values.length > 0) {
        const sum = values.reduce((acc, val) => acc + val, 0);
        dimensionalIndices[dim.id] = sum / values.length;
      } else {
        dimensionalIndices[dim.id] = null;
      }
    });

    let globalIndex = 0;
    questionnaire.getDimensions().forEach((dim) => {
      const value = dimensionalIndices[dim.id];
      if (value !== null) {
        globalIndex += value * dim.weight;
      }
    });

    return {
      globalIndex,
      dimensionalIndices,
      questionNormalized: normalizedValues,
    };
  },

  getInterpretation: (score) => {
    if (score >= 85) return { text: 'Excelente', color: 'text-emerald-600', bg: 'bg-emerald-600' };
    if (score >= 70) return { text: 'Bueno', color: 'text-lime-600', bg: 'bg-lime-600' };
    if (score >= 55) return { text: 'Aceptable', color: 'text-amber-600', bg: 'bg-amber-500' };
    if (score >= 40) return { text: 'Alerta', color: 'text-orange-600', bg: 'bg-orange-600' };
    return { text: 'Crítico', color: 'text-rose-600', bg: 'bg-rose-600' };
  },
};

export default methodology;
